/**
 * @generated SignedSource<<e6baef5ddd2df05dd2a37990225e647b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AgentPoolPageBulkAssignProjectWithAgentPoolMutation$variables = {
  agentPoolRawId: string;
  exclusively?: boolean | null | undefined;
  projectRawIds: ReadonlyArray<string>;
};
export type AgentPoolPageBulkAssignProjectWithAgentPoolMutation$data = {
  readonly bulkAssignProjectWithAgentPool: {
    readonly agentPool: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type AgentPoolPageBulkAssignProjectWithAgentPoolMutation = {
  response: AgentPoolPageBulkAssignProjectWithAgentPoolMutation$data;
  variables: AgentPoolPageBulkAssignProjectWithAgentPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentPoolRawId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "exclusively"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectRawIds"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "agentPoolRawId",
            "variableName": "agentPoolRawId"
          },
          {
            "kind": "Variable",
            "name": "exclusively",
            "variableName": "exclusively"
          },
          {
            "kind": "Variable",
            "name": "projectRawIds",
            "variableName": "projectRawIds"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkAssignProjectWithAgentPoolPayload",
    "kind": "LinkedField",
    "name": "bulkAssignProjectWithAgentPool",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgentPool",
        "kind": "LinkedField",
        "name": "agentPool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentPoolPageBulkAssignProjectWithAgentPoolMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentPoolPageBulkAssignProjectWithAgentPoolMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "26d8e49acde75f3120e77037efacb3da",
    "id": null,
    "metadata": {},
    "name": "AgentPoolPageBulkAssignProjectWithAgentPoolMutation",
    "operationKind": "mutation",
    "text": "mutation AgentPoolPageBulkAssignProjectWithAgentPoolMutation(\n  $projectRawIds: [ID!]!\n  $agentPoolRawId: ID!\n  $exclusively: Boolean = false\n) {\n  bulkAssignProjectWithAgentPool(input: {projectRawIds: $projectRawIds, agentPoolRawId: $agentPoolRawId, exclusively: $exclusively}) {\n    agentPool {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08c9e2ffc6425d36e47534b6d6628e7a";

export default node;
